"use client";

import { getSession } from "next-auth/react";
import { useEffect, useRef } from "react";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import { AUTH_CLEAR_SESSION_PATH } from "@/app/vars/Urls";

type Props = {
  isAuthenticated: boolean;
};

export default function SessionGuard(props: Props) {
  const { isAuthenticated } = props;

  const user = useAuthUser();
  const clearing = useRef(false);

  useEffect(() => {
    if (isAuthenticated || !user || clearing.current) {
      return;
    }

    clearing.current = true;

    getSession().then((session) => {
      if (session) {
        clearing.current = false;
        return;
      }

      window.location.href = AUTH_CLEAR_SESSION_PATH;
    });
  }, [isAuthenticated, user]);

  return null;
}
